module.exports = __webpack_public_path__ + "static/media/logo.a0d93963.svg";